// extracted by mini-css-extract-plugin
module.exports = {"article-image-epi":"styles_article-image-epi__zXBdm","cover-image":"styles_cover-image__wLNjW","epigraphe":"styles_epigraphe__bSqPY"};